export const STUDIES = [
  { value: 'BRUCELOSIS', label: 'Brucelosis', fields: ['bpa', 'fpa'] },
  { value: 'BVD', label: 'Diarrea Viral Bovina', fields: ['elisa_p80_p125'] },
  { value: 'CAMPYLOBACTER', label: 'Campylobacter fetus', fields: ['qpcr_campylobacter'] },
  { value: 'TRITRICHOMONAS', label: 'Tritrichomonas foetus', fields: ['qpcr_tritrichomonas'] },
];
export const COLUMNS = [
  ['bpa', 'BPA'], ['fpa', 'FPA'], ['elisa_p80_p125', 'ELISA p80/p125'],
  ['qpcr_campylobacter', 'qPCR Campylobacter fetus spp'], ['qpcr_tritrichomonas', 'qPCR Tritrichomonas foetus'],
];
export const SAMPLE_FIELDS = ['identificacion', 'numero_de_muestras'];
export const FIELDS = [...SAMPLE_FIELDS, ...COLUMNS.map(([field]) => field)];
export const uuid = () => window.crypto?.randomUUID?.() || 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
  const r = Math.floor(Math.random() * 16);
  return (c === 'x' ? r : (r & 3) | 8).toString(16);
});
export const rowKey = (row) => row.detalle_id ? `detalle-${row.detalle_id}` : row.protocolo_muestra || row.client_id;
export const valueOf = (row, field) => field === 'numero_de_muestras' ? Number(row?.[field] ?? 1) : String(row?.[field] ?? '');
export const blankRow = (number, extra = {}) => ({
  client_id: uuid(), numero_orden: number, identificacion: '', numero_de_muestras: 1,
  ...Object.fromEntries(COLUMNS.map(([field]) => [field, ''])), ...extra,
});
export function changesFor(rows, base, fields = FIELDS) {
  return rows.flatMap((row) => {
    if (row.muestra_activa === false) return [];
    const old = base.find((item) => rowKey(item) === rowKey(row));
    const changed = fields.filter((field) => !old ? SAMPLE_FIELDS.includes(field) || valueOf(row, field) !== '' : valueOf(row, field) !== valueOf(old, field));
    if (!changed.length) return [];
    return [{ client_id: rowKey(row), protocolo_muestra: row.protocolo_muestra || null,
      ...(row.detalle_id ? { detalle_id: row.detalle_id } : {}),
      ...(row.protocolo_lote ? { protocolo_lote: row.protocolo_lote } : {}),
      cambios: Object.fromEntries(changed.map((field) => [field, valueOf(row, field)])),
      originales: old ? Object.fromEntries(changed.map((field) => [field, valueOf(old, field)])) : {},
    }];
  });
}

// Refrescar metadatos al volver de editar sin perder cambios ni su valor original.
export function mergeRemote(remote, rows, base) {
  const mergedBase = [], mergedRows = [];
  remote.forEach((fresh) => {
    const local = rows.find((row) => rowKey(row) === rowKey(fresh));
    const old = base.find((row) => rowKey(row) === rowKey(fresh));
    const next = { ...fresh }, baseline = { ...fresh };
    if (local && old) FIELDS.forEach((field) => {
      if (valueOf(local, field) !== valueOf(old, field)) {
        next[field] = local[field];
        baseline[field] = old[field];
      }
    });
    mergedRows.push(next); mergedBase.push(baseline);
  });
  return { rows: [...mergedRows, ...rows.filter((row) => !row.protocolo_muestra)], base: mergedBase };
}

export function parseAnimals(text) {
  const errors = [], animals = [];
  text.split(/\r?\n/).forEach((line, index) => {
    if (!line.trim()) return;
    const cells = line.split('\t');
    const identificacion = cells[0].trim();
    const cantidad = cells.length > 1 ? cells[1].trim() : '1';
    if (cells.length > 7) {
      errors.push(`Línea ${index + 1}: pega hasta siete columnas: identificación, cantidad, BPA, FPA, ELISA p80/p125 y las dos qPCR.`);
      return;
    }
    if (identificacion.length > 100 || !/^\d+$/.test(cantidad) || Number(cantidad) < 1 || Number(cantidad) > 2147483647) {
      errors.push(`Línea ${index + 1}: usa identificación opcional (máximo 100 caracteres) y cantidad entera positiva. Copia las celdas de Excel sin encabezados.`);
      return;
    }
    const animal = { identificacion, numero_de_muestras: Number(cantidad) };
    let valid = true;
    COLUMNS.forEach(([field, label], column) => {
      const value = (cells[column + 2] || '').trim();
      if (value.length > 50) {
        errors.push(`Línea ${index + 1}: ${label} admite hasta 50 caracteres.`);
        valid = false;
      } else if (value) animal[field] = value;
    });
    if (valid) animals.push(animal);
  });
  return { animals, errors };
}

let owner = null;
let drafts = {};
let version = 0;
const listeners = new Set();
const notify = () => { version += 1; listeners.forEach((listener) => listener()); };
export const subscribeDrafts = (listener) => { listeners.add(listener); return () => listeners.delete(listener); };
export const draftVersion = () => version;
export const clearPackDrafts = () => { drafts = {}; owner = null; notify(); };
const ensureOwner = () => {
  const token = localStorage.getItem('token');
  if (token !== owner) { drafts = {}; owner = token; }
};
export const getDraft = (protocol) => { ensureOwner(); return drafts[protocol]; };
export const putDraft = (protocol, draft) => { ensureOwner(); drafts = { ...drafts, [protocol]: draft }; notify(); };
export const dropDraft = (protocol) => { delete drafts[protocol]; notify(); };
export const pendingDrafts = () => Object.entries(drafts).filter(([, draft]) => draft.pending || changesFor(draft.rows, draft.base).length);
